// import { transformResponse } from '../transformer';
import * as http from '~/utils/apis';
export const API_PREFIX = 'cms-api/hero-saga/basic-stats';
import { camelizeKeys } from '~/utils/helpers';

const basicStatApi = {
    index: async () => {
        const { data } = await http.get(`${API_PREFIX}`);

        return camelizeKeys(data);
    },

    update: async (body) => {
        await http.put(`${API_PREFIX}`, body, {});
    },
};

export default basicStatApi;
